var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-3 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/events", role: "button" }
              },
              [_vm._v("\n                  back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive text-center" }, [
        _c(
          "table",
          { staticClass: "table table-light table-bordered table-hover" },
          [
            _c(
              "draggable",
              {
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: function($event) {
                    _vm.drag = false
                  }
                },
                model: {
                  value: _vm.archiveEvents.data,
                  callback: function($$v) {
                    _vm.$set(_vm.archiveEvents, "data", $$v)
                  },
                  expression: "archiveEvents.data"
                }
              },
              _vm._l(_vm.archiveEvents.data, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.start_date))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("img", {
                      staticClass: "table-thumbnail",
                      attrs: { title: item.title, src: item.img_url }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.title))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(item.type === "1" ? "Live" : "Talk"))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.eventAttendeesCount))])
                ])
              }),
              0
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "offset-md-3 col-md-6 text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-fill btn-block",
            on: { click: _vm.updateEventListing }
          },
          [_vm._v("\n              Update Listings Order\n            ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [
        _vm._v("Archive Events - Setup Order")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("You can change events list ordering by drag and drop !")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2edaa107", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2edaa107","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Events/OrderArchiveEvents.vue
// module id = mObg
// module chunks = 0